<div class="container px-0 mb-homepage-search">
  <div class="form-inline">
    <div class="form-group mb-homepage-search-box-wrapper">
      <div class="form-control mb-homepage-search-box">
        <mb-search-box-component [searchQuery]="query"
                                 (searchTerm)="handleSearchForTerm($event)"
        >
        </mb-search-box-component>
      </div>

      <div class="form-control mb-homepage-filter-box my-0 ml-2 cursor-pointer user-select-none"
           (click)="showFacets()"
      >
        <div>
          <img src="../../../../assets/images/Icon_settings.svg"
               class="px-0 h-100 mx-2 mb-0 mb-md-1 mt-2 mt-md-0 mb-search-item-icons"
               alt="Show filter pane icon"
               title="Filter pane Icon"
               aria-label="Filter pane"
               data-cy="mb-search-filter-icon"
          />
          <div class="d-inline-block hidden-xs hidden-sm h-100 pt-2 mr-2">
            {{'searchFilterPane.filter' | mbTranslate}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isFilterActive && !facetsNumber">
    <cx-spinner></cx-spinner>
  </ng-container>

  <div *ngIf="isFilterActive"
       class="px-2 px-md-0 py-2 mx-0 my-0 mb-homepage-facets"
  >
    <ng-container *ngFor="let facet of facets$ | async | slice:0:variableNumberOfVisibleFacets; let i = index">
      <div [ngClass]="[i < visibleFacetNumber ? 'fixed-height' : '', 'row no-gutters px-0 pb-1 user-select-none mb-homepage-facets-box']">
        <span class="col-11 mb-2 mt-3 cursor-pointer mb-homepage-facet-name"
              (click)="showFilter(i)"
        >
            {{facet.name}}
        </span>

        <ng-container *ngIf="i < visibleFacetNumber || filtersToggleStatus[i]; else elseBlock">
          <ng-container *ngIf="facet?.values?.length > visibleFacetValuesNumber + 1 || i >= visibleFacetNumber">
            <div class="col-1 px-0 mx-0 my-0 text-right">
              <div *ngIf="i < visibleFacetNumber && !filtersToggleStatus[i]; else showMinusSymbol"
                   class="mb-2 mt-3 mx-3 cursor-pointer mb-homepage-facet-toggle"
                   (click)="showFilter(i)"
              >+
              </div>

              <ng-template #showMinusSymbol>
                <div class="mb-2 mt-3 mx-3 cursor-pointer mb-homepage-facet-toggle"
                     (click)="showFilter(i)"
                >–
                </div>
              </ng-template>
            </div>
          </ng-container>

          <div [ngClass]="['col-12 pl-3 d-block']">
            <ng-container *ngFor="let facetVal of facet?.values; index as index">
              <ng-container *ngIf="i < visibleFacetNumber && index > visibleFacetValuesNumber && !filtersToggleStatus[i]; else showAllValues">
                <a *ngIf="index === visibleFacetValuesNumber + 1"
                   #facetValue
                   [ngClass]="['d-inline-flex mr-2 mb-homepage-facet-value-more']"
                   [attr.data-cy]="'mb-homepage-facet-' + index"
                   (click)="showFilter(i)"
                >
                  <span class="label">
                    {{ 'mbcommon.more' | mbTranslate }}
                  </span>
                </a>
              </ng-container>

              <ng-template #showAllValues>
                <br *ngIf="i < visibleFacetNumber && index === visibleFacetValuesNumber + 1"/>
                <a #facetValue
                   [ngClass]="[facetVal?.selected ? 'selected' : '', isDesktopDevice ? 'is-desktop-device' : '', 'd-inline-flex mr-2 mb-homepage-facet-value']"
                   [class.selected]="facetVal.selected"
                   [attr.data-cy]="'mb-homepage-facet-' + index"
                   (click)="selectFacetValue(facetVal, facet)"
                >
                  <span *ngIf="!facetVal?.displayName" class="label" [innerHTML]="facetVal?.name | safeHtml"></span>
                  <span *ngIf="facetVal?.displayName" class="label" [innerHTML]="facetVal?.displayName | safeHtml"></span>
                </a>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>

        <ng-template #elseBlock>
          <div class="col-1 px-0 mx-0 my-0 text-right">
            <div class="mb-2 mt-3 mx-3 cursor-pointer mb-homepage-facet-toggle"
                 (click)="showFilter(i)"
            >+
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="facetsNumber > visibleFacetNumber">
      <ng-container *ngIf="!showMoreFacetsOverall">
        <div class="row no-gutters px-0 pb-1 user-select-none mb-homepage-facets-box fixed-height">
          <a [ngClass]="['col-11 my-3 mb-homepage-facet-more']"
             (click)="showMoreFacets()"
          >
            <span class="label">
              {{ 'homepageSearch.showMoreFacetFilters' | mbTranslate }}
            </span>
          </a>
          <div class="col my-3 mr-3 text-right">
            <button type="button"
                    aria-label="Show more facets"
                    data-cy="mb-homepage-filter-toggle-down"
                    class="mb-homepage-filter-toggle-down"
                    (click)="showMoreFacets()"
            >
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showMoreFacetsOverall">
        <div class="row no-gutters px-0 pb-1 user-select-none mb-homepage-facets-box">
          <a [ngClass]="['col-11 my-2 mb-homepage-facet-less']"
             (click)="showMoreFacets()"
          >
            <span class="label">
              {{ 'homepageSearch.showLessFacetFilters' | mbTranslate }}
            </span>
          </a>
          <div class="col my-2 mr-3 text-right">
            <button type="button"
                    aria-label="Show less facets"
                    data-cy="mb-homepage-filter-toggle-up"
                    class="mb-homepage-filter-toggle-up"
                    (click)="showMoreFacets()"
            >
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div *ngIf="isFilterActive"
       class="px-2 px-md-0 py-2 mx-0 my-0"
  >
    <div class="row no-gutters mb-2 px-0 pb-1">
      <div class="col-11 mb-homepage-facet-results-btn">
        <button type="button"
                data-cy="mb-homepage-facet-results-btn"
                class="btn btn-primary text-initial"
                [disabled]="!query?.length && !searchTerm?.length"
                (click)="goToSearchResults()"
        >
          <strong>{{ 'homepageSearch.goToSearchResults' | mbTranslate }}</strong>
        </button>
      </div>
      <div class="col mr-3 text-right">
        <button type="button"
                aria-label="Close"
                data-cy="mb-homepage-facet-close"
                class="mb-homepage-facet-close close"
                (click)="showFacets()"
        >
        </button>
      </div>
    </div>
  </div>
</div>

